export const improve_eng = [
  {
    id: "text",
    type: "textarea",
    placeholder: "Paste the text you want to improve here",
    template: "Please revise the following text:\n      {{value}}",
  },
  //   {
  //     id: "focus",
  //     type: "dropdown",
  //     choices: ["Formal Writing", "Informal Writing", "Conversational English"],
  //     template: "* Focusing on {{value}}",
  //   },
  {
    id: "targetAudience",
    type: "dropdown",
    choices: [
      "General audience",
      "Academics",
      "Business professionals",
      "Friends",
    ],
    template: "* The intended audience is {{value}}.",
  },
  {
    id: "improvements",
    type: "checkbox",
    choices: [
      {
        value:
          "- Grammar: Correct grammatical errors and ensure proper sentence structure.",
        title: "Grammar",
        description:
          "Correct grammatical errors and ensure proper sentence structure.",
      },
      {
        value: "- Clarity: Make my writing easier to understand.",
        title: "Clarity",
        description: "Make my writing easier to understand.",
      },
      {
        value:
          "- Vocabulary: Use more sophisticated or precise vocabulary where appropriate.",
        title: "Vocabulary",
        description:
          "Use more sophisticated or precise vocabulary where appropriate.",
      },
      {
        value:
          "- Conciseness: Express my ideas in a more concise and to-the-point manner.",
        title: "Conciseness",
        description:
          "Express my ideas in a more concise and to-the-point manner.",
      },
      {
        value:
          "- Sentence Connections: Improve the flow and transitions between sentences.",
        title: "Sentence Connections",
        description: "Improve the flow and transitions between sentences.",
      },
      {
        value:
          "- Natural Language: Help my writing sound more like a native speaker.",
        title: "Natural Language",
        description: "Help my writing sound more like a native speaker.",
      },
    ],
    template: "I want you to focus on improving: \n{{value}}",
    separator: "\n",
  },
  {
    id: "previousConversation",
    type: "textarea",
    placeholder:
      "If this prompt builds on a previous conversation, paste the relevant parts here to provide context to the AI.",
    template:
      "--- Previous Conversation ---\n{{value}}\n--- End Previous Conversation ---\n\n",
    optional: true,
  },
  {
    id: "fewShotExample",
    type: "textarea",
    placeholder:
      "To help the AI understand your preferences, provide an example of a sentence or short paragraph written in the style you're aiming for.",
    template: "Here's an example of the desired style:\n{{value}}\n\n",
    optional: true,
  },
  {
    id: "formality",
    type: "dropdown",
    choices: ["Very Casual", "Casual", "Neutral", "Formal", "Very Formal"],
    template: "* Revise to a {{value}} level of formality.",
    onChange: (value, fields) => {
      const toneField = fields.find((o) => o.id === "tone");

      switch (value) {
        case "Very Casual":
          toneField.choices = ["Humorous"];
          break;
        case "Casual":
          toneField.choices = ["Friendly", "Humorous"];
          break;
        case "Neutral":
          toneField.choices = [
            "Friendly",
            "Neutral",
            "Informative",
            "Persuasive",
          ];
          break;
        case "Formal":
          toneField.choices = ["Neutral", "Informative", "Persuasive"];
          break;
        case "Very Formal":
          toneField.choices = ["Neutral", "Informative"];
          break;
        default:
          toneField.choices = [
            "Friendly",
            "Neutral",
            "Informative",
            "Persuasive",
            "Humorous",
          ];
      }

      return { tone: toneField };
    },
  },
  {
    id: "tone",
    type: "dropdown",
    choices: ["Friendly", "Neutral", "Informative", "Persuasive", "Humorous"],
    template: "* Ensure the tone is {{value}}.",
  },
  {
    id: "situation",
    type: "dropdown",
    choices: [
      "Everyday conversation",
      "Email/letter",
      "Presentation/speech",
      "Academic paper",
      "Job interview",
      "Social media post",
      "Creative writing",
    ],
    template:
      "* This sentence will be used in the following situation: {{value}}.",
    allowOther: true,
  },
  {
    id: "specificIssues",
    type: "textarea",
    placeholder:
      "Describe any specific grammar issues or areas you want to improve (e.g., tense consistency, preposition usage)",
    template: "* Pay attention to these specific issues: {{value}}",
    optional: true,
  },
  {
    id: "lengthPreference",
    type: "dropdown",
    choices: ["Shorter", "Longer"],
    template: "* I would prefer the revised sentence to be {{value}}.",
    optional: true,
  },
  {
    id: "context",
    type: "textarea",
    placeholder: "Provide any additional context (optional)",
    template: "Additional context:\n{{value}}",
    optional: true,
  },
];
